exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ksper[data-v-9c6f920a]{color:#80063a;padding:6px 0;font-size:14px;font-weight:700\n}\n.ksper span[data-v-9c6f920a]{margin:0 10px\n}\n.ksper svg[data-v-9c6f920a]{margin-right:2px;margin-bottom:3px\n}", ""]);

// exports
